import { imageAdapter } from '@/adapters/constructor/utils/image';

export default ({ data }) => {
  return {
    title: data.title,
    text: data.text,
    image: imageAdapter(data.banner, data.banner_mobile),

    facts: data.facts,
  };
};
